module.exports = __webpack_public_path__ + "s16.no2.01123bcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s16.no2.jpg
// module id = AVSF
// module chunks = 0